<div class="wrapper">
  <ng-content></ng-content>
</div>

<agc-preloader *ngIf="loading"></agc-preloader>
